export var makeBackgroundVariant = function makeBackgroundVariant(_ref) {
  var colors = _ref.theme.colors,
      variant = _ref.variant,
      mode = _ref.mode;

  if (!variant) {
    return;
  }

  return {
    backgroundColor: mode === 'light' ? colors[variant].lighter : colors[variant].dark
  };
};
export var makeTextColorVariant = function makeTextColorVariant(_ref2) {
  var colors = _ref2.theme.colors,
      variant = _ref2.variant,
      mode = _ref2.mode;

  if (!variant) {
    return;
  }

  return {
    color: mode === 'light' ? colors[variant].darker : colors[variant].lighter
  };
};